import { Icon, Tooltip, ITooltip } from '@sanlam-glacier/app-common/components';
import { Fragment, PropsWithChildren } from 'react';
import styles from './icon-tooltip.module.scss';
import clsx from 'clsx';
import { Grid, Block } from '@sanlam-glacier/app-common/modules/grid';
import { Bullet } from 'components/atoms/html-symbols/Bullet';

interface IconTooltipProps {
  position?: ITooltip['position'];
  icon?: string;
  className?: string;
  iconClassName?: string;
  iconSize?: string;
}

export const IconTooltip = ({
  position,
  icon = 'action_help',
  className,
  children,
  iconClassName,
  iconSize
}: PropsWithChildren<IconTooltipProps>) => {
  return (
    <Tooltip position={position} content={children}>
      <span className={clsx(styles.iconWrapper, className)}>
        <Icon icon={icon} className={clsx(styles.defaultTooltipIcon, iconClassName, iconSize)} />
      </span>
    </Tooltip>
  );
};

export const IconTooltipList = ({ header, items }: { header: string; items: string[] }) => {
  return (
    <>
      {header}
      <Grid gap={0}>
        {items.map((item) => (
          <Fragment key={item}>
            <Block sm={12}>
              <span className={styles.bullet}>
                <Bullet />
              </span>
              {item}
            </Block>
          </Fragment>
        ))}
      </Grid>
    </>
  );
};
